import React, { useEffect, useState, useMemo } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import TeamRankingWidget from '../../components/stats/TeamRankingWidget';
import { getRankingCompetitionMeta, getWidgetConfiguration } from '../../../api';
import { resolveWidgetDisplayTitle } from '../../utils/widgetDisplayTitle';

export default function TeamRankingPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const competitionIdsParam = searchParams.get('competitionIds') || '';
  const widgetConfigurationId = searchParams.get('widgetConfigurationId') || '';

  const [widgetConfig, setWidgetConfig] = useState(null);

  const competitionIds = useMemo(
    () =>
      competitionIdsParam
        .split(',')
        .map((id) => id.trim())
        .filter(Boolean),
    [competitionIdsParam]
  );

  const firstCompetitionId = competitionIds[0];

  const [discipline, setDiscipline] = useState(null);
  const [season, setSeason] = useState(null);
  const [title, setTitle] = useState('Statistiques équipes');
  const [metaResolved, setMetaResolved] = useState(false);

  useEffect(() => {
    let ignore = false;

    const loadMeta = async () => {
      setMetaResolved(false);

      if (!firstCompetitionId) {
        if (!ignore) {
          setDiscipline(null);
          setSeason(null);
          setTitle('Statistiques équipes');
          setMetaResolved(true);
        }
        return;
      }

      try {
        const { data } = await getRankingCompetitionMeta(firstCompetitionId);

        if (!ignore) {
          setDiscipline(data?.discipline || null);
          setSeason(data?.season || null);
          setTitle(
            competitionIds.length > 1
              ? 'Statistiques équipes'
              : data?.name || 'Statistiques équipes'
          );
          setMetaResolved(true);
        }
      } catch (error) {
        if (!ignore) {
          setDiscipline(null);
          setSeason(null);
          setTitle('Statistiques équipes');
          setMetaResolved(true);
        }
      }
    };

    loadMeta();

    return () => {
      ignore = true;
    };
  }, [firstCompetitionId, competitionIds.length]);

  useEffect(() => {
  let ignore = false;

  const loadWidgetConfig = async () => {
    if (!widgetConfigurationId) {
      if (!ignore) setWidgetConfig(null);
      return;
    }

    try {
      const { data } = await getWidgetConfiguration(widgetConfigurationId);
      if (!ignore) setWidgetConfig(data || null);
    } catch {
      if (!ignore) setWidgetConfig(null);
    }
  };

  loadWidgetConfig();

  return () => {
    ignore = true;
  };
}, [widgetConfigurationId]);

const resolvedTitle = useMemo(
  () => resolveWidgetDisplayTitle({ widgetConfig, fallbackTitle: title }),
  [widgetConfig, title]
);

  if (!metaResolved) return null;
  if (!discipline || competitionIds.length === 0) return null;

  return (
    <TeamRankingWidget
      discipline={discipline}
      season={season}
      competitionIds={competitionIds}
      widgetConfigurationId={widgetConfigurationId || null}
      title={resolvedTitle}
      onNavigate={(url) => navigate(url)}
    />
  );
}